/**
 * 缓存说明:svg树
 */
import vm from './storeTools.js'
import svgApi from '@/components/api/svgApi.js'

var basestate = {
	svgTree: undefined, //当前可以查看的svg树
	pageIdToSvg: {},
	nowSvgItem: undefined,//当前的svg图形
}

var store = new vm.Vuex.Store({
	state: copy(basestate),
	getters: {
		getSvgTree(state, getters) {
			if (state.svgTree == undefined) {
				store.commit("getSvgTree")
				return {}
			}
			return state.svgTree
		},
		getSvgByPageId(state) {
			return pageId => {
				if (state.pageIdToSvg[pageId] == undefined) {
					store.commit('getSvgByPageId', pageId)
					return undefined
				}
				return state.pageIdToSvg[pageId]
			}
		},
		getNowSvgItem(state){
			return state.nowSvgItem
		}
	},
	mutations: {
		clear() {
			//清理缓存
			store.replaceState(copy(basestate))
		},
		getSvgTree(state) {
			svgApi.getSvgTree(respon => {
				vm.Vue.set(state, 'svgTree', respon)
			})
		},
		getSvgByPageId(state, pageId) {
			svgApi.get(pageId, respon => {
				if (respon == undefined) {
					vm.Vue.set(state.pageIdToSvg, pageId, {})
				} else {
					vm.Vue.set(state.pageIdToSvg, pageId, respon)
				}
			})
		},
		updateSvgTree(state, msg) {
			function updateTree(tree, pathMap) {
				if (tree.entityName == 'PagePojo' || tree.entityName == 'Page') {
					var info = pathMap[tree.path]
					if (info != undefined) {
						//找到了,修改版本号
						var fileName = tree.fileName.substring(0, tree.fileName.lastIndexOf('.', tree.fileName.lastIndexOf('.') - 1))+'.'+info.nowVersion+'.svg'
						vm.Vue.set(tree,'fileName',fileName)
					}
				} else if(tree.hasOwnProperty('next')) {
					for (var i = 0, len = tree.next.length; i < len; i++) {
						var item = tree.next[i]
						updateTree(item, pathMap)
					}
				}

			}
			//收到新的svg变更消息以后，根据内容递归更新svgtree
			var dataList = JSON.parse(msg)
			var pathMap = {}
			for (var i = 0, len = dataList.length; i < len; i++) {
				var item = dataList[i]
				pathMap[item.path] = item
			}
			updateTree(state.svgTree, pathMap)
		},
		getNowSvg(state,val){
			state.nowSvgItem  = val
		}

	}
});

//对外提供
export default store

/**
 * 需要分页的内容,以数组存储全部,取的时候进行分页,
 * 刷新时获取指定页数据,然后合并,重复的数据以新的为准,
 * 可能会导致缺失遗漏,但是有清理缓存就可以了
 */
